import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ISuccessStepProps } from '../../types';
import { CHANNEL_INFO, T_KEYS } from '../../constants';
import {
  SuccessBanner,
  SuccessLogos,
  MsoolLogo,
  SuccessCheckmark,
  SuccessContent,
  SuccessTitle,
  SuccessDescription,
  ChannelLogo,
} from '../../styles';

// Import channel SVGs
import AIRBNB from '@assets/svg/airbnb.svg?react';
import GATHERN from '@assets/svg/gathren.svg?react';
import BookingIcon from '@assets/svg/BookingLogo.svg?react';
import MsoolIcon from '@assets/svg/MsoolIcon.svg?react';

const SuccessStep: FC<ISuccessStepProps> = memo(({
  channelName,
  onImportNow,
  onImportLater,
}) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const channelInfo = CHANNEL_INFO[channelName];
  const displayName = isRtl ? channelInfo.displayNameAr : channelInfo.displayName;

  const getChannelLogo = () => {
    switch (channelName) {
      case 'airbnb':
        return <AIRBNB />;
      case 'booking':
        return <BookingIcon />;
      case 'gathern':
        return <GATHERN />;
      default:
        return null;
    }
  };

  return (
    <SuccessBanner>
      <SuccessContent>
        <SuccessTitle>
          {t(T_KEYS.CONNECTION_SUCCESS, { channel: displayName })}
        </SuccessTitle>
        <SuccessDescription>
          {t(T_KEYS.CONNECTION_SUCCESS_DESC, { channel: displayName })}
        </SuccessDescription>
      </SuccessContent>
      <SuccessLogos>
        <MsoolLogo>
          <MsoolIcon />
        </MsoolLogo>
        <SuccessCheckmark>✓</SuccessCheckmark>
        <ChannelLogo>
          {getChannelLogo()}
        </ChannelLogo>
      </SuccessLogos>
    </SuccessBanner>
  );
});

SuccessStep.displayName = 'SuccessStep';

export default SuccessStep;
